<template>
  <div class="order-details">
    <!--标题-->
    <div class="breadcrumb" style="background: #fff">客户详情</div>
    <div class="third-title"><span>平台信息</span></div>
    <div class="order-detail-basic">
      <el-form :model="platformList" label-width="100px">
        <el-form-item label="客户姓名:">
          <el-input v-model="platformList.fullName" placeholder="请输入内容" clearable></el-input>
        </el-form-item>
        <el-form-item label="手机号:"> {{ platformList.phone }} </el-form-item>
        <el-form-item label="地址:"> {{ platformList.address === undefined ? '' : platformList.address.completeAddress }} </el-form-item>
        <el-form-item label="注册日期:"> {{ platformList.registerTime }} </el-form-item>
        <el-form-item label="平台号:"> {{ platformList.store === undefined ? '' : platformList.store.code }} </el-form-item>
        <el-form-item label="平台名称:"> {{ platformList.store === undefined ? '' : platformList.store.name }} </el-form-item>
        <el-form-item label="客户类型:">
          <el-select v-model="platformList.userType" placeholder="请选择">
            <el-option v-for="item in userTypeList" :key="item.userType" :label="item.name" :value="item.userType">
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
    </div>
    <div class="third-title"><span>收货信息</span></div>
    <el-table :data="tableData" border style="width: 50%;margin:15px 0 0 220px">
      <el-table-column prop="person" label="收货人">
      </el-table-column>
      <el-table-column prop="phone" label="手机号">
      </el-table-column>
      <el-table-column prop="completeAddress" label="地址">
      </el-table-column>
    </el-table>
    <div class="edit-button">
      <el-button type="primary" @click="onSubmit" round>确定</el-button>
    </div>
    <CombinedDialog ref="dialogRef"></CombinedDialog>
    <add-address-dialog ref="addressDialogRef" @addAddress="getNewAddress"></add-address-dialog>
  </div>
</template>
 <script>
import store from '@/store'
import CombinedDialog from '@/components/Dialog/CombinedDialog/index.vue'
import AddAddressDialog from '@/components/Dialog/AddAddressDialog/index.vue'
import { orderById } from '@/api/oms'
import { addressGetAddressById, userUpdate, addressGetAddressByUserId, userQueryByUserId, userGetUserTypeList } from '@/api/crm'
export default {
  name: 'order-details',
  components: {
    CombinedDialog,
    AddAddressDialog
  },
  data () {
    return {
      userTypeList: [],
      id: this.$route.query.id,
      basicInfo: {},
      platformList: {
        platformNum: '747447',
        platformName: '7876332',
        phone: '546636+6566',
        address: '51564841561'
      },
      tableData: [{
        taskNum: '20160502',
        skuName: '王大虎',
        proName: '上海市普陀区金沙江路 1518 弄',
        platformPrice: '物流信息',
        count: 4,
        platPAll: '',
        remark: '7',
        taskStatus: '已上传',
        kuaidi: ''
      }],
      balance: 10000, // 余额支付
      gridData: [{
        date: '2016-05-02',
        name: '王小虎',
        address: '上海'
      }],
      type: -1
    }
  },
  created () {
    this.type = store.state.systemType
    this.getUserMsg()
  },
  methods: {
    getUserTypeList () {
      userGetUserTypeList(1).then(res => {
        if (res.data.success) {
          this.userTypeList = res.data.data
          this.userTypeList.push({ userType: this.platformList.userType, name: this.platformList.typeName })
        }
      })
    },
    getUserMsg () {
      userQueryByUserId(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.platformList = res.data.data
          this.getUserTypeList()
        }
      })
      addressGetAddressByUserId(this.$route.query.id).then(res => {
        if (res.data.success) {
          this.tableData = res.data.data
        }
      })
    },
    getAddressMsg (id) {
      addressGetAddressById(id).then(res => {
        this.platformList.subOrders[0].addressMsg = res.data.data
      })
    },
    getNewAddress (val) {
      this.basicInfo.username = val[0]
      this.basicInfo.phone = val[5]
      this.basicInfo.address = val[1] + '省 ' + val[2] + '市 ' + val[3] + ' ' + val[4]
    },
    checkPayment () {
      this.$refs.dialogRef.show('balanceapply', '确定提示', this.balance, '', '', 'balanceapply')
    },
    onSubmit () {
      const { fullName, id, userType } = this.platformList
      userUpdate({ fullName, id, userType: userType }).then(res => {
        if (res.data.success) {
          this.$message.success('修改成功')
          this.$router.go(-1)
        }
      })
    }
  }
}
</script>
 <style scoped lang="less">
 @deep: ~">>>";
 @import "index.less";
 </style>
